module.exports = __webpack_public_path__ + "image/product-banner.jpg";